import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import BusinessIcon from '@mui/icons-material/Business';
import Avatar from '@mui/material/Avatar';
import SendIcon from '@mui/icons-material/Send';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import DialogNuevo from "./Observaciones/DialogNuevo";
import SinObs from "./Observaciones/SinObs";
import PushPinIcon from '@mui/icons-material/PushPin';

//CUSTOM IMPORTS
import { UrlApi } from "../../../../services/apirest";
import { Divider, Tooltip } from "@mui/material";

const INTERNO_COLOR = "#c8b860";
const INTERNO_COLOR_LIGHT = "#f5f0da";
const CHOFER_COLOR = "#22adeeff";
const CHOFER_COLOR_LIGHT = "#e8eefdff";

export default function DialogObservacionesPedido(props) {
    console.log(props)
    const { pedido } = props;
    const scrollRef = useRef(null);

    const obsTablaPedidos = [
        ...(pedido?.observaciones
            ? [{
                id_pedido: pedido.idpedido,
                observacion: pedido.observaciones,
                usuario: pedido.usuario,
                para_chofer: 1,
                created_at: "",
                nro_reparto: pedido?.nro_reparto
            }]
            : []),

        ...(pedido?.obs_chofer
            ? [{
                id_pedido: pedido.idpedido,
                observacion: pedido.obs_chofer,
                usuario: pedido.usuario_choferentrega,
                para_chofer: 0,
                created_at: "",
                nro_reparto: pedido?.nro_reparto
            }]
            : [])
    ];

    const [obsHistorial, setObsHistorial] = useState([...obsTablaPedidos]);
    const [nuevaObservacion, setNuevaObservacion] = useState("");

    useEffect(() => {
        getObsHistorial();
    }, [pedido]);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [obsHistorial]);


    const getObsHistorial = () => {
        fetch(`${UrlApi}/pedidos_obs_historial/id_pedido/${pedido?.idpedido}`)
            .then((data) => data.json())
            .then((data) => {
                setObsHistorial([...obsTablaPedidos, ...data]);
            });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const res = await fetch(`${UrlApi}/pedidos_obs_historial`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id_pedido: pedido?.idpedido,
                observacion: event.target.observacion.value,
                usuario: localStorage.getItem("user"),
                para_chofer: 1,
                nro_reparto: pedido?.nro_reparto,
                fija: 0
            }),
        })
        const json = await res.json();

        if (json.message === "OK") {
            setObsHistorial((prev) => [
                ...prev,
                {
                    id_pedido: pedido?.idpedido,
                    observacion: event.target.observacion.value,
                    usuario: localStorage.getItem("user"),
                    para_chofer: 1,
                    created_at: new Date(),
                    nro_reparto: pedido?.nro_reparto,
                    fija: 0
                },
            ]);
            setNuevaObservacion("")
        } else {
            alert("Error: No se pudo enviar la observación. Contacte a sistemas.")
        }
    };

    const icono = <LocalShippingIcon sx={{ fontSize: 22 }} />;

    const children = () => {
        return (
            <>
                {obsHistorial?.length === 0 && (
                    <SinObs />
                )}
                {
                    obsHistorial?.filter(obs => obs.fija === 1 || (obs.nro_reparto === pedido?.nro_reparto || !obs.nro_reparto)).map((obs, index) => {
                        const isChofer = obs.para_chofer === 0;

                        const bubbleColor = isChofer ? CHOFER_COLOR_LIGHT : INTERNO_COLOR_LIGHT;
                        const accentColor = isChofer ? CHOFER_COLOR : INTERNO_COLOR;
                        const fecha = obs?.created_at
                            ? moment(obs?.created_at).format("DD/MM/YYYY HH:mm")
                            : "";
                        return (
                            <Box key={index} sx={{ display: "flex", flexDirection: "column" }}>
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        flexDirection: !isChofer ? "row" : "row-reverse",
                                        alignItems: "flex-end",
                                        gap: 1,
                                    }}
                                    p={2}
                                >

                                    <Avatar
                                        sx={{
                                            bgcolor: accentColor,
                                            width: 32,
                                            height: 32,
                                            fontSize: 13,
                                            fontWeight: 700,
                                            flexShrink: 0,
                                        }}
                                    >
                                        {isChofer ? (
                                            <LocalShippingIcon sx={{ fontSize: 16 }} />
                                        ) : (
                                            <BusinessIcon sx={{ fontSize: 16 }} />
                                        )}
                                    </Avatar>
                                    <Box
                                        sx={{
                                            maxWidth: "75%",
                                            bgcolor: bubbleColor,
                                            borderRadius: isChofer
                                                ? "12px 12px 12px 2px"
                                                : "12px 12px 2px 12px",
                                            px: 2,
                                            py: 1.5,
                                            position: "relative",
                                            border: `1px solid ${accentColor}30`,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                gap: 2,
                                                mb: 0.5,
                                            }}
                                        >

                                            <Typography
                                                variant="caption"
                                                sx={{ fontWeight: 700, color: accentColor }}
                                            >
                                                {obs.usuario}
                                            </Typography>
                                            {fecha && (
                                                <Typography
                                                    variant="caption"
                                                    sx={{ color: "#888", fontSize: 10, whiteSpace: "nowrap" }}
                                                >
                                                    {fecha}
                                                </Typography>
                                            )}
                                        </Box>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: "#333", lineHeight: 1.5, wordBreak: "break-word" }}
                                        >
                                            {obs.fija === 1 && <PushPinIcon sx={{ fontSize: 16, color: "warning.main" }} />}
                                            {obs.observacion}
                                        </Typography>
                                    </Box>
                                </Box>
                                {isChofer && (
                                    <Box px={2} pb={1}>
                                        <Divider>
                                            <Chip
                                                label="Este pedido debe ser reasignado por entrega fallida en reparto anterior."
                                                size="small"
                                                sx={{backgroundColor:"#FFD580", borderColor:"#ce8465"}}
                                            />
                                        </Divider>
                                    </Box>
                                )}
                            </Box>

                        )

                    })
                }

                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    id="subscription-form"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 2,
                        py: 1.5,
                        borderTop: "1px solid #e0e0e0",
                        bgcolor: "#fff",
                    }}
                >
                    <TextField
                        helperText={"Será visible para el chofer ÚNICAMENTE la última observación."}
                        multiline
                        rows={2}
                        autoFocus
                        required
                        name="observacion"
                        placeholder="Escribir observacion..."
                        value={nuevaObservacion}
                        onChange={(e) => setNuevaObservacion(e.target.value)}
                        type="text"
                        fullWidth
                        size="small"
                        variant="outlined"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 3,
                                bgcolor: "#f5f5f5",
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        type="submit"
                                        form="subscription-form"
                                        disabled={!nuevaObservacion.trim()}
                                        sx={{
                                            bgcolor: nuevaObservacion.trim() ? INTERNO_COLOR : "transparent",
                                            color: nuevaObservacion.trim() ? "#fff" : "#bbb",
                                            width: 32,
                                            height: 32,
                                            "&:hover": {
                                                bgcolor: nuevaObservacion.trim() ? "#1a8abf" : "transparent",
                                            },
                                        }}
                                    >
                                        <Tooltip title="Enviar observación">
                                            <SendIcon sx={{ fontSize: 18 }} />
                                        </Tooltip>
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            </>
        )
    }

    return (
        <>
            <DialogNuevo
                open={props.open}
                handleClose={props.handleClose}
                titulo="Observaciones Logística/Chofer"
                subtitulo={`Pedido #${pedido?.idpedido}`}
                children={children()}
                icono={icono}
            />
        </>
    )
}